/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import BtnMultiFilter from '../../Components/Utility/FilterAction/BtnMultiFilter';
import Loader from '../../Components/Utility/Loader/Loader';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import './SupplierSuggestion.css';
import * as action from './store/SupplierSuggestion.action';
import { Page_Size, getYears, monthsPlaceholder, shortenandHoverString } from '../../Components/helper';
import noImage from '../../assets/images/no-image.png';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import { ChevronIcon, InfoIcon, AddIcon, PreviewIcon, EditIcon, DeleteIcon } from '../../bombiix-icon';
import { getPCTypesDetails, getMultiSubBrandDetails, getCatBasedOnPT } from '../SystemMasters/Store/SystemMasters.action';
import { getSuggestionActionColumnWidth } from './suggestion-action-column';
import { useProductLandingPath } from '../../Components/CustomHooks/useProductLandingPath';

function SuggestionList() {
  const dispatch = useDispatch();
  const suggestionListReducer = useSelector((reducerstate) => reducerstate);
  const { UserDetails, SupplierSuggestion, Users } = suggestionListReducer;
  const { userInfo, isSupplierLoggedIn, userRole } = UserDetails;
  const { section } = SupplierSuggestion;
  const { logInRights } = Users;
  const careLabel = 'care-label';

  const history = useHistory();
  const productLandingPath = useProductLandingPath();
  const { CheckActionPermission } = useComponent();

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [index, setIndex] = useState(null);
  const [confirmLoader, setConfirmLoader] = useState(false);
  const [filterListArray, setFilterListArray] = useState([]);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);
  const { t } = useTranslation('common');

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  const toCheckAddEditPermission = (name) => {
    return CheckActionPermission(logInRights, 'products', name, 'addEdit');
  };

  const switchToAccessModal = (name) => {
    switch (name) {
      case 'bom':
        return toCheckAddEditPermission('bom');
      case 'measurement':
        return toCheckAddEditPermission('measurement');
      case 'testing':
        return toCheckAddEditPermission('testing');
      case 'product-information':
        return toCheckAddEditPermission('product-information');
      default:
        return toCheckAddEditPermission('care');
    }
  };

  // LogedIn User ID
  const loggedInUserId = userInfo.userId;
  const [state, setState] = useState({
    suggestionListArray: [],
    deleteId: null,
    pageIndex: 1,
    pageSize: Page_Size,
    hasMore: true,
    loading: true,
    totalRecords: null,
    sortOrder: '',
    sortPropertyName: '',
    multipaleFilters: false,
  });
  const [sortTable, setSortTable] = useState({
    sortOrder: '',
    sortPropertyName: '',
    supplierId: '',
    pageIndex: 1,
    pageSize: Page_Size,
  });

  const setYearData = async () => {
    const yearOptions = await createOptions(getYears());
    return [
      {
        name: 'year',
        multiSelect: true,
        placeHolder: t('FILTER_OPTIONS.YEAR.PLACEHOLDER'),
        options: yearOptions,
      },
    ];
  };
  const setMonthData = async () => {
    const monthOptions = await createOptions(monthsPlaceholder);
    return [
      {
        name: 'month',
        multiSelect: true,
        placeHolder: t('FILTER_OPTIONS.MONTH.PLACEHOLDER'),
        options: monthOptions,
      },
    ];
  };

  const setProductTypeData = async () => {
    const pcTypeList = await dispatch(
      getPCTypesDetails({
        loggedInUserId: userInfo?.userId,
        isActive: true,
        tier: 'Tier1',
      }),
    );
    const productType = await createOptions(pcTypeList);
    return [
      {
        name: 'productType',
        multiSelect: true,
        placeHolder: t('FILTER_OPTIONS.PRODUCT_TYPE.PLACEHOLDER'),
        options: productType,
      },
    ];
  };

  const set_brandsData = async () => {
    const BrandRes = await dispatch(
      action.fetchAllBrandAction({
        accessedFrom: 'masters',
        loggedInUserId,
      }),
    );

    const brandsOpt = await createOptions(BrandRes);
    return [
      {
        name: 'brand',
        multiSelect: true,
        placeHolder: t('FILTER_OPTIONS.BRAND.PLACEHOLDER'),
        options: brandsOpt,
      },
    ];
  };

  const setSubBrandData = async (brandIds = []) => {
    const SubBrandRes = await dispatch(
      getMultiSubBrandDetails({
        brandId: brandIds,
        loggedInUserId,
      }),
    );

    const subBrandsOpt = await createOptions(SubBrandRes);
    return [
      {
        name: 'subBrand',
        multiSelect: true,
        placeHolder: 'Select Sub Brand',
        options: subBrandsOpt,
      },
    ];
  };

  const setCategoryData = async (type, name, placeHolder, categoryIds) => {
    let catOneRes = [];
    if (type !== null) {
      catOneRes = await dispatch(
        action.fetchCategoryAction({
          accessedFrom: 'masters',
          categoryType: type,
          ...categoryIds,
          loggedInUserId,
        }),
      );
    }

    const catOneOpt = await createOptions(catOneRes);
    return [
      {
        name,
        placeHolder,
        multiSelect: true,
        options: catOneOpt || [],
      },
    ];
  };

  const setSeasonsData = async () => {
    const seasonsRes = await dispatch(
      action.getSeasonsAction({
        loggedInUserId,
      }),
    );
    const seasonsOpt = await createOptions(seasonsRes);
    return [
      {
        name: 'season',
        multiSelect: true,
        placeHolder: t('FILTER_OPTIONS.SEASON.PLACEHOLDER'),
        options: seasonsOpt,
      },
    ];
  };

  const setStatusData = async () => {
    const status = await createOptions(['Approved', 'Rejected', 'Pending']);
    return [
      {
        name: 'status',
        multiSelect: false,
        placeHolder: t('FILTER_OPTIONS.STATUS.PLACEHOLDER'),
        options: status,
      },
    ];
  };

  const setSectionData = () => {
    return [
      {
        name: 'section',
        multiSelect: false,
        placeHolder: t('FILTER_OPTIONS.SECTION.PLACEHOLDER'),
        options: section,
      },
    ];
  };

  const setActionTypeData = async () => {
    const actionType = await createOptions([
      { name: 'Amendment', _id: 'amendment' },
      { name: 'New', _id: 'new' },
    ]);
    return [
      {
        name: 'actionType',
        multiSelect: false,
        placeHolder: t('FILTER_OPTIONS.ACTION_TYPE.PLACEHOLDER'),
        options: actionType,
      },
    ];
  };

  const setSupplierData = async () => {
    if (userInfo.role === 'Admin') {
      const supp_list = await getSupplierList();
      const supplierOpt = await createOptions(supp_list);
      return [
        {
          name: 'supplier',
          multiSelect: true,
          placeHolder: t('FILTER_OPTIONS.SUPPLIER.PLACEHOLDER'),
          options: supplierOpt || [],
        },
      ];
    }
    return [];
  };

  const loadFilterListArray = async (data) => {
    setFilterListArray(data);
  };

  const onInit = async () => {
    const brands = await set_brandsData();
    const subBrands = await setSubBrandData(state?.brand || []);
    const catOne = await setCategoryData(1, 'category1', 'Select Category 1', {});
    const catTwo = await setCategoryData(2, 'category2', 'Select Category 2', {});
    const cat3 = await setCategoryData(3, 'category3', 'Select Category 3', {});
    const cat4 = await setCategoryData(4, 'category4', 'Select Category 4', {});
    const seasons = await setSeasonsData();

    const sectionArray = setSectionData();
    const statusArray = await setStatusData();
    const actionTypeArray = await setActionTypeData();

    const supplierArray = await setSupplierData();
    const yearData = await setYearData();
    const monthData = await setMonthData();
    const productTypeData = await setProductTypeData();

    const params = [
      ...brands,
      ...subBrands,
      ...productTypeData,
      ...catOne,
      ...catTwo,
      ...cat3,
      ...cat4,
      ...seasons,
      ...sectionArray,
      ...statusArray,
      ...actionTypeArray,
      ...supplierArray,
      ...yearData,
      ...monthData,
    ];
    loadFilterListArray(params);
  };

  const getSuggestionData = async (data, text) => {
    if (data.totalRecords !== null && data.suggestionListArray && data.suggestionListArray.length >= data.totalRecords) {
      setState((prev) => ({
        ...prev,
        hasMore: false,
      }));
      return;
    }

    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params = {
      pageIndex: data.pageIndex,
      pageSize: data.pageSize,
    };

    if (userRole === 'Supplier') {
      params.supplierId = loggedInUserId;
    }
    if (data.year) params.year = data.year;
    if (data.month) params.month = data.month;
    if (data.productType) params.productType = data.productType;
    if (data.brand) params.brand = data.brand;
    if (data.subBrand) params.subBrand = data.subBrand;
    if (data.category1) params.category1 = data.category1;
    if (data.category2) params.category2 = data.category2;
    if (data.category3) params.category3 = data.category3;
    if (data.category4) params.category4 = data.category4;
    if (data.season) params.seasons = data.season;
    if (data.section) params.section = data.section;
    if (data.status) params.status = data.status;
    if (data.actionType) params.actionType = data.actionType;
    if (data.supplier) params.supplier = data.supplier;
    if (data.sortOrder) params.sortOrder = data.sortOrder;
    if (data.sortPropertyName) {
      params.sortPropertyName = data.sortPropertyName;
    }
    const resData = await dispatch(action.getSuggestionList(params));
    if (resData) {
      const { doc, totalCount } = resData;
      let oldData = [];
      if (text === 'scroll') {
        oldData = data.suggestionListArray ? [...data.suggestionListArray, ...doc] : [];
      } else {
        oldData = doc;
      }
      setState((prev) => ({
        ...prev,
        suggestionListArray: oldData,
        hasMore: oldData.length < totalCount,
        pageIndex: data.pageIndex + 1,
        loading: false,
        totalRecords: doc ? totalCount : 0,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const createOptions = async (array) => {
    let data = [];
    if (array?.length > 0) {
      data = await array.map((item, i) => {
        return {
          ...item, // Preserve all original properties including brandId
          label: item.name || item,
          value: item._id || item,
        };
      });
    }
    return data;
  };
  console.log('filterListArray', filterListArray);

  const nextCategory = async (cat, type) => {
    const { category1, category2, category3 } = cat;
    const queryStringCat1Array = [];
    const queryStringCat2Array = [];
    const queryStringCat3Array = [];

    category1?.map((item) => queryStringCat1Array.push(item.value));

    category2?.map((item) => queryStringCat2Array.push(item.value));

    category3?.map((item) => queryStringCat3Array.push(item.value));

    if (type === 'category2') {
      const cat3 = await setCategoryData(3, 'category3', 'Select Category 3', {
        categoryOneId: queryStringCat1Array,
        categoryTwoId: queryStringCat2Array,
        isActive: 1,
      });
      const ind = filterListArray.findIndex((item) => item.name === 'category3');
      await filterListArray.splice(ind, 1, ...cat3);
      setFilterListArray((prev) => [...prev]);
    }

    if (type === 'category3') {
      const cat4 = await setCategoryData(4, 'category4', 'Select Category 4', {
        categoryOneId: queryStringCat1Array,
        categoryTwoId: queryStringCat2Array,
        categoryThreeId: queryStringCat3Array,
        isActive: 1,
      });

      const index = filterListArray.findIndex((item) => item.name === 'category4');
      await filterListArray.splice(index, 1, ...cat4);
      setFilterListArray(() => [...filterListArray]);
    }
  };

  const onDelete = (id) => {
    setShowConfirmationPopup(!showConfirmationPopup);
    setIndex(id);
  };

  const closeConfirmationsPopup = () => {
    setShowConfirmationPopup(false);
    setIndex(null);
  };
  const deleteSupplierConfirmed = async () => {
    setConfirmLoader(true);
    const obj = {
      suggestionId: index,
    };
    const status = await dispatch(action.deleteSupplier(obj, t));
    if (status === 200) {
      await deleteSuggestion();
    }
    setConfirmLoader(false);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const deleteSuggestion = async () => {
    const params = {
      ...state,
      pageIndex: 1,
      pageSize: state.pageSize,
      suggestionListArray: [],
      totalRecords: null,
    };
    await getSuggestionData(params, 'onDelete');
  };

  const showMeasurementStatus = (dataStatus) => {
    let totalLibrary;
    let totalLibApproved;
    let totalLibRejected;
    let totalLibDeleted = 0;

    dataStatus?.forEach((measurementItem) => {
      totalLibrary = parseInt(measurementItem?.pomLibraries?.length) + parseInt(measurementItem?.specPomLibraries?.length);
      totalLibApproved =
        parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Approved').length) +
        parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Approved').length);

      totalLibRejected =
        parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Rejected').length) +
        parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Rejected').length);

      totalLibDeleted =
        parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Deleted').length) +
        parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Deleted').length);
    });
    return <>{returnSections(totalLibrary, totalLibApproved, totalLibRejected, totalLibDeleted)}</>;
  };

  const returnSections = (totalLibrary, totalLibApproved, totalLibRejected, totalLibDeleted) => {
    if (totalLibrary === totalLibApproved) {
      return (
        <>
          <span>
            <strong>{t('FILTER_OPTIONS.CATEGORY_SELECTION.APPROVED')}</strong>
          </span>
          <span className="col-status right approved" />
        </>
      );
    }
    if (totalLibrary === totalLibRejected) {
      return (
        <>
          <span>
            <strong>{t('FILTER_OPTIONS.CATEGORY_SELECTION.REJECTED')}</strong>
          </span>
          <span className="col-status right rejected" />
        </>
      );
    }
    if (totalLibrary === totalLibDeleted) {
      return (
        <span>
          <strong>{t('FILTER_OPTIONS.CATEGORY_SELECTION.DELETED')}</strong>
        </span>
      );
    }
    if (totalLibApproved === 0 && totalLibRejected === 0) {
      return (
        <>
          <span>
            <strong>{t('FILTER_OPTIONS.CATEGORY_SELECTION.PENDING')}</strong>
          </span>
          <span className="col-status right pending" />
        </>
      );
    }
    return (
      <>
        <span>
          <strong>
            {t('FILTER_OPTIONS.CATEGORY_SELECTION.MULTIPLE')} (+{totalLibrary - 1})
          </strong>
        </span>
        <span className="col-status right multiple" />
      </>
    );
  };

  const getStatusCount = (tabs, Status) => {
    // Create a Set to store unique rowIds that have pending status
    const uniqueRowIdsWithPending = new Set();

    // Iterate through each tab
    tabs?.forEach((tab) => {
      // Check if tab has tabDetails
      if (tab?.tabDetails?.length > 0) {
        // Iterate through tabDetails
        tab?.tabDetails?.forEach((detail) => {
          // Check if status is pending and add rowId to Set if true
          if (detail?.status === Status && detail?.rowId) {
            uniqueRowIdsWithPending.add(detail.rowId);
          }
        });
      }
    });

    // Return the size of the Set (number of unique rowIds with pending status)
    return uniqueRowIdsWithPending.size;
  };

  const showCareLabelStatus = (dataStatus) => {
    let totalLibrary;
    let totalLibApproved;
    let totalLibRejected;
    let totalLibDeleted = 0;

    dataStatus?.forEach((careLibItem) => {
      // Create a Set to store unique rowIds that have pending status
      const uniqueRowIdsWithPending = new Set();

      // Iterate through each tab
      careLibItem?.tabs?.forEach((tab) => {
        // Check if tab has tabDetails
        if (tab?.tabDetails?.length > 0) {
          // Iterate through tabDetails
          tab?.tabDetails?.forEach((detail) => {
            // Check if status is pending and add rowId to Set if true
            if (detail?.rowId) {
              uniqueRowIdsWithPending.add(detail.rowId);
            }
          });
        }
      });
      // Return the size of the Set (number of unique rowIds with pending status)
      totalLibrary = uniqueRowIdsWithPending.size ? uniqueRowIdsWithPending.size : 0;
      totalLibApproved = getStatusCount(careLibItem?.tabs, 'Approved');
      totalLibRejected = getStatusCount(careLibItem?.tabs, 'Rejected');
      totalLibDeleted = getStatusCount(careLibItem?.tabs, 'Deleted');
    });
    return <>{returnSections(totalLibrary, totalLibApproved, totalLibRejected, totalLibDeleted)}</>;
  };

  const showStatus = (dataStatus) => {
    let totalLibrary;
    let totalLibApproved;
    let totalLibRejected;
    let totalLibDeleted = 0;

    totalLibrary = parseInt(dataStatus?.length, 10);

    totalLibApproved = parseInt(dataStatus?.filter((x) => x.status === 'Approved').length, 10);

    totalLibRejected = parseInt(dataStatus?.filter((x) => x.status === 'Rejected').length, 10);

    totalLibDeleted = parseInt(dataStatus?.filter((x) => x.status === 'Deleted').length, 10);

    return <>{returnSections(totalLibrary, totalLibApproved, totalLibRejected, totalLibDeleted)}</>;
  };

  const onApplyFilter = async (filter) => {
    Object.keys(filter).forEach((key) => {
      if (filter[key] === undefined) delete filter[key];
    });
    const { brand, subBrand, category1, category2, category3, category4, supplier, season, year, month, productType } = filter;
    let filterDataObj = {};

    if (userRole === 'Supplier') {
      filterDataObj.supplierId = loggedInUserId;
    }
    filterDataObj = {
      ...filterDataObj,
      suggestionListArray: state.suggestionListArray,
      brand: brand?.map((x) => x.value) || [],
      subBrand: subBrand?.map((x) => x.value) || [],
      category1: category1?.map((x) => x.value),
      category2: category2?.map((x) => x.value),
      category3: category3?.map((x) => x.value),
      category4: category4?.map((x) => x.value),
      year: year?.map((x) => x.value),
      month: month?.map((x) => x.value),
      productType: productType?.map((x) => x.value),
      season: season?.map((x) => x.value),
      supplier: supplier?.map((x) => x.value),
      section: filter.section,
      status: filter.status,
      actionType: filter.actionType,
      sortOrder: state.sortOrder,
      sortPropertyName: state.sortPropertyName,
      pageSize: Page_Size,
      pageIndex: 1,
      multipaleFilters: true,
    };
    const localStorageObj = {
      ...filter,
    };
    localStorage.setItem('supplierSuggestionFilter', JSON.stringify(localStorageObj));
    setState((prev) => ({
      ...prev,
      suggestionListArray: state.suggestionListArray,
      brand: filterDataObj.brand,
      subBrand: filterDataObj.subBrand,
      category1: filterDataObj.category1,
      category2: filterDataObj.category2,
      category3: filterDataObj.category3,
      category4: filterDataObj.category4,
      season: filterDataObj.season,
      supplier: filterDataObj.supplier,
      section: filter.section,
      status: filter.status,
      actionType: filter.actionType,
      sortOrder: state.sortOrder,
      sortPropertyName: state.sortPropertyName,
      pageSize: Page_Size,
      pageIndex: 1,
      multipaleFilters: true,
      year: filterDataObj.year,
      month: filterDataObj.month,
      productType: filterDataObj.productType,
    }));
    await getSuggestionData(filterDataObj, 'reset');
  };

  const filterOnChange = async (filterObj) => {
    const obj = filterObj || {};
    const { category1, category2, category3, category4, fieldName, brand } = obj;
    if (category1 || category2 || category3 || category4) {
      setTimeout(() => {
        nextCategory(filterObj, fieldName);
      }, 500);
    }
    // Handle subBrand options based on selected brand(s)
    if (fieldName === 'brand') {
      const selectedBrandIds = brand?.map((x) => x.value) || [];
      const subBrandParams = await setSubBrandData(selectedBrandIds);
      const ind = filterListArray.findIndex((item) => item.name === 'subBrand');
      if (ind !== -1) {
        filterListArray.splice(ind, 1, ...subBrandParams);
        setFilterListArray(() => [...filterListArray]);
      }
    }
  };

  const onResetFilter = async () => {
    setState(() => ({
      suggestionListArray: [],
      pageIndex: 1,
      pageSize: Page_Size,
      hasMore: true,
      loading: true,
      totalRecords: null,
      sortOrder: '',
      sortPropertyName: '',
      multipaleFilters: false,
    }));

    const params = {
      pageIndex: 1,
      pageSize: Page_Size,
      suggestionListArray: [],
      totalRecords: null,
    };
    if (userRole === 'Supplier') {
      params.supplierId = loggedInUserId;
    }
    localStorage.setItem('supplierSuggestionFilter', JSON.stringify({}));
    await getSuggestionData(params, 'reset');
  };

  const getSupplierList = async () => {
    if (userInfo.role === 'Admin') {
      return await dispatch(
        action.getSupplierSuggestSupplier({
          accessedFrom: 'masters',
          loggedInUserId,
        }),
      );
    }
  };

  const handleNextPagesInScroll = async () => {
    const params = {
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,

      brand: state.brand,
      subBrand: state.subBrand,
      category1: state.category1,
      category2: state.category2,
      category3: state.category3,
      category4: state.category4,
      season: state.season,
      supplier: state.supplier,
      section: state.section,
      status: state.status,
      actionType: state.actionType,
      sortOrder: state.sortOrder,
      sortPropertyName: state.sortPropertyName,
      totalRecords: state.totalRecords,
      suggestionListArray: state.suggestionListArray,
    };
    await getSuggestionData(params, 'scroll');
  };

  const onSortColumn = async (propertyName) => {
    let sortObj = {};
    if (userRole === 'Supplier') {
      sortTable.supplierId = loggedInUserId;
    }
    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      suggestionListArray: [],
      totalRecords: null,
      hasMore: true,
      sortPropertyName: propertyName,
    }));

    if (sortTable.sortOrder === '' || sortTable.sortOrder === 'Desc') {
      sortObj = {
        pageIndex: 1,
        pageSize: Page_Size,
        loading: true,
        hasMore: true,
        totalRecords: null,

        suggestionListArray: [],
        brand: state.brand,
        subBrand: state.subBrand,
        category1: state.category1,
        category2: state.category2,
        category3: state.category3,
        category4: state.category4,
        season: state.season,
        supplier: state.supplier,
        section: state.section,
        status: state.status,
        actionType: state.actionType,

        sortOrder: 'Asc',
        sortPropertyName: propertyName,
      };

      setState((prev) => ({
        ...prev,
        sortPropertyName: propertyName,
        sortOrder: 'Asc',
      }));
    } else {
      sortObj = {
        pageIndex: 1,
        pageSize: Page_Size,
        loading: true,
        hasMore: true,
        totalRecords: null,

        suggestionListArray: [],
        brand: state.brand,
        subBrand: state.subBrand,
        category1: state.category1,
        category2: state.category2,
        category3: state.category3,
        category4: state.category4,
        season: state.season,
        supplier: state.supplier,
        section: state.section,
        status: state.status,
        actionType: state.actionType,

        sortOrder: 'Desc',
        sortPropertyName: propertyName,
      };
      setState((prev) => ({
        ...prev,
        sortPropertyName: propertyName,
        sortOrder: 'Desc',
      }));
    }
    setSortTable(sortObj);
  };

  // all useEffect

  useEffect(() => {
    let params = {
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,
      suggestionListArray: state.suggestionListArray,
      totalRecords: state.totalRecords,
    };
    const obj = JSON.parse(localStorage.getItem('supplierSuggestionFilter'));
    params = {
      ...params,
      brand: (obj?.brand && obj?.brand.map((x) => x.value)) || [],
      subBrand: (obj?.subBrand && obj?.subBrand.map((x) => x.value)) || [],
      category1: obj?.category1 && obj?.category1.map((x) => x.value),
      category2: obj?.category2 && obj?.category2.map((x) => x.value),
      category3: obj?.category3 && obj?.category3.map((x) => x.value),
      category4: obj?.category4 && obj?.category4.map((x) => x.value),
      year: obj?.year && obj?.year.map((x) => x.value),
      month: obj?.month && obj?.month.map((x) => x.value),
      productType: obj?.productType && obj?.productType.map((x) => x.value),
      season: obj?.season && obj?.season.map((x) => x.value),
      supplier: obj?.supplier && obj?.supplier.map((x) => x.value),
      section: obj?.section,
      status: obj?.status,
      actionType: obj?.actionType,
    };
    setState((prev) => ({
      ...prev,
      brand: params?.brand,
      subBrand: params?.subBrand,
      category1: params?.category1,
      category2: params?.category2,
      category3: params?.category3,
      category4: params?.category4,
      season: params?.season,
      supplier: params?.supplier,
      section: params?.section,
      status: params?.status,
      actionType: params?.actionType,
      year: params?.year,
      month: params?.month,
      productType: params?.productType,
    }));

    if (userRole === 'Supplier') {
      params.supplierId = loggedInUserId;
    }
    const getSugList = async () => {
      await getSuggestionData(params, 'init');
    };

    getSugList();
    onInit();
  }, []);

  useEffect(() => {
    const multifilter = async () => {
      if (state.multipaleFilters) {
        setState((prev) => ({
          ...prev,
          loading: true,
          pageIndex: 1,
          suggestionListArray: [],
          totalRecords: null,
          hasMore: true,
        }));

        const params = {
          pageIndex: 1,
          pageSize: state.pageSize,
          brand: state.brand,
          subBrand: state.subBrand,
          category1: state.category1,
          category2: state.category2,
          category3: state.category3,
          category4: state.category4,
          season: state.season,
          supplier: state.supplier,
          section: state.section,
          status: state.status,
          actionType: state.actionType,
          sortOrder: state.sortOrder,
          sortPropertyName: state.sortPropertyName,
          suggestionListArray: [],
          totalRecords: null,
          multipaleFilters: true,
        };
        if (userRole === 'Supplier') {
          params.supplierId = loggedInUserId;
        }
        await getSuggestionData(params, 'multifilter');
        setState((prev) => ({
          ...prev,
          loading: false,
          multipaleFilters: false,
        }));
      }
    };

    multifilter();
  }, []);

  useEffect(() => {
    const apiCall = async () => {
      if (sortTable.sortOrder && sortTable.sortPropertyName) await getSuggestionData(sortTable, 'onSortColumn');
    };
    apiCall();
  }, [sortTable]);

  const routeToSection = (item) => {
    switch (item?.section) {
      case 'testing':
        history.push(`/development-order/${item.devOrderIds[0]}/testing/testing-requirements`);
        break;
      case careLabel:
        history.push(`/development-order/${item.devOrderIds[0]}/care-user-instruction`);
        break;
      case 'product-information':
        history.push(productLandingPath(item.devOrderIds[0]));
        break;
      default:
        history.push(`/development-order/${item.devOrderIds[0]}/${item?.section}`);
        break;
    }
  };

  const showHideBtn = (item) => {
    const section = item?.section;
    const isSupplier = userRole === 'Supplier';
    let showBtn = false;
    let totalLibApproved;
    let totalLibRejected;
    let totalLibPending = 0;

    switch (section) {
      case 'bom':
        const bomDataArr = item.bomComponents;
        totalLibApproved = parseInt(bomDataArr.filter((x) => x.status === 'Approved').length);
        totalLibRejected = parseInt(bomDataArr.filter((x) => x.status === 'Rejected').length);

        totalLibPending = parseInt(bomDataArr.filter((x) => x.status === 'Pending' || x.status === 'pending').length);
        break;
      case 'product-information':
        const productDataArr = item.productInformationLibraries;
        totalLibApproved = parseInt(productDataArr?.filter((x) => x.status === 'Approved').length);
        totalLibRejected = parseInt(productDataArr?.filter((x) => x.status === 'Rejected').length);
        totalLibPending = parseInt(productDataArr?.filter((x) => x.status === 'Pending' || x.status === 'pending').length);
        break;

      case 'testing':
        const dataArr = item.testLibraries;
        totalLibApproved = parseInt(dataArr.filter((x) => x.status === 'Approved').length);
        totalLibRejected = parseInt(dataArr.filter((x) => x.status === 'Rejected').length);

        totalLibPending = parseInt(dataArr.filter((x) => x.status === 'Pending' || x.status === 'pending').length);
        break;
      case 'measurement':
        const measureData = item.measurementLibaries;

        measureData?.forEach((measurementItem) => {
          totalLibApproved =
            parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Approved').length) +
            parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Approved').length);
          totalLibRejected =
            parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Rejected').length) +
            parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Rejected').length);

          totalLibPending =
            parseInt(measurementItem?.pomLibraries?.filter((x) => x.status === 'Pending' || x.status === 'pending').length) +
            parseInt(measurementItem?.specPomLibraries?.filter((x) => x.status === 'Pending' || x.status === 'pending').length);
        });
        break;
      case careLabel:
        const careLabData = item.careLableLibaries;

        careLabData?.forEach((careLibItem) => {
          totalLibApproved = getStatusCount(careLibItem?.tabs, 'Approved');
          totalLibRejected = getStatusCount(careLibItem?.tabs, 'Rejected');
          totalLibPending = getStatusCount(careLibItem?.tabs, 'Pending');
        });
        break;
      default:
        break;
    }

    if ((totalLibApproved > 0 || totalLibPending > 0 || totalLibRejected > 0) && isSupplier) {
      showBtn = true;
    }
    if ((totalLibPending > 0 || totalLibRejected > 0) && !totalLibApproved && isSupplier) {
      showBtn = true;
    }

    if (totalLibApproved > 0 && totalLibPending === 0 && totalLibRejected === 0 && isSupplier) {
      showBtn = false;
    }
    return showBtn;
  };

  const editSuggesDetails = (item) => {
    history.push({
      pathname: `/supplier-suggestion/edit/${item._id}/${item?.section}`,
    });
  };

  const returnObject = () => {
    return sortTable.sortOrder === 'Asc' ? (
      <ChevronIcon size={24} className="text-black ml-1" />
    ) : (
      <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />
    );
  };

  const showCreatedandModified = (item) => {
    return (
      <button aria-label="Information" type="button" className="btn p-0 d-inline-flex">
        <OverlayTrigger
          placement="bottom"
          trigger="hover"
          rootClose
          overlay={
            <Popover className="custom-popover modified-popover">
              <Popover.Content>
                <div>
                  <p className="text-left m-0">
                    <strong> {t('FILTER_OPTIONS.CATEGORY_SELECTION.CREATED_AT')} </strong>
                    {moment(item.createdAt).format('DD-MM-YYYY, h:mm a')}
                  </p>
                  <p className="text-left m-0">
                    <strong> {t('FILTER_OPTIONS.CATEGORY_SELECTION.CREATED_BY')}&nbsp;</strong>

                    {item.createdBy}
                  </p>
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <span className="d-inline-flex"><InfoIcon size={28} /></span>
        </OverlayTrigger>
      </button>
    );
  };

  const renderSectionDisplays = (item) => {
    // Case 1: BOM section - display translated bill of material text
    if (item.section === 'bom') {
      return t('FILTER_OPTIONS.CATEGORY_SELECTION.BILL_OF_MATERIAL');
    }

    // Case 2: Care label section - display translated care label text
    if (item.section === careLabel) {
      return t('FILTER_OPTIONS.CATEGORY_SELECTION.CARE_LABEL');
    }

    // Case 3: Default case - display capitalized section name
    return <span className="text-capitalize">{item.section}</span>;
  };

  const hasEditAction = (state.suggestionListArray ?? []).some((item) => showHideBtn(item));
  const actionColumnWidth = getSuggestionActionColumnWidth(hasEditAction);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('TOP_NAVBAR.SUPPLIER_SUGGESTS')}</h4>
        </div>
        <div className="search-filter bom_filter_btn">
          {isSupplierLoggedIn && (
            <CustomTooltip tooltipText={t('APPROVE_REJECTS.ADD')}>
              <button aria-label="Add" type="button" onClick={() => history.push('/supplier-suggestion/add')} className="btn p-0 d-inline-flex">
                <AddIcon size={28} />
              </button>
            </CustomTooltip>
          )}
          <BtnMultiFilter
            filterList={filterListArray}
            onApplyFilter={onApplyFilter}
            filterOnChange={filterOnChange}
            onResetFilter={onResetFilter}
            ClassName="mr-2"
            isValueFromOption
            ptCascading={catBasedOnPTData}
          />
        </div>
      </div>
      <div className="container-fluid pt-4">
        <div id="scrollableDivSuggestion" className="supplier-suggest-scroll-container">
          <InfiniteScroll
            dataLength={state.suggestionListArray.length} // This is important field to render the next data
            hasMore={state.hasMore}
            next={() => handleNextPagesInScroll()}
            loader={state.loading && <Loader />}
            scrollableTarget="scrollableDivSuggestion"
            className="fixed-col-container"
          >
            <table
              id="suggestion-table"
              className="table common-custom-table  mb-0 fixed-header layout-fixed"
              style={{ '--suggestion-action-col-width': `${actionColumnWidth}px` }}
            >
              <thead>
                <tr>
                  <th className="w-100px">{t('FILTER_OPTIONS.CATEGORY_SELECTION.IMAGE')}</th>
                  <th
                    className="w-150px first-fix-col"
                    onClick={() => {
                      onSortColumn('number');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">{t('FILTER_OPTIONS.CATEGORY_SELECTION.PRODUCT_REF')}</span>
                  </th>

                  <th
                    className="w-200px"
                    onClick={() => {
                      onSortColumn('description');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">{t('FILTER_OPTIONS.CATEGORY_SELECTION.DESCRIPTION')}</span>
                  </th>

                  <th
                    className="w-150px"
                    onClick={() => {
                      onSortColumn('brandId');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('FILTER_OPTIONS.CATEGORY_SELECTION.BRAND')}
                      {sortTable?.sortPropertyName === 'brandId' ? returnObject() : <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />}
                    </span>
                  </th>
                  <th
                    className="w-150px"
                    onClick={() => {
                      onSortColumn('subBrandId');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('COLOUR_LIBRARYS.COLOUR_LIBRARY_GROUP.ADD_EDIT_COLOUR_GROUP.SUBBRAND')}
                      {sortTable?.sortPropertyName === 'subBrandId' ? returnObject() : <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />}
                    </span>
                  </th>
                  <th
                    className="w-120px"
                    onClick={() => {
                      onSortColumn('catOneId');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('FILTER_OPTIONS.CATEGORY_SELECTION.CATEGORIES_1')}
                      {sortTable?.sortPropertyName === 'catOneId' ? returnObject() : <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />}
                    </span>
                  </th>

                  <th
                    className="w-120px"
                    onClick={() => {
                      onSortColumn('catTwoId');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('FILTER_OPTIONS.CATEGORY_SELECTION.CATEGORIES_2')}
                      {sortTable?.sortPropertyName === 'catTwoId' ? returnObject() : <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />}
                    </span>
                  </th>
                  <th
                    className="w-120px"
                    onClick={() => {
                      onSortColumn('catThreeId');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('FILTER_OPTIONS.CATEGORY_SELECTION.CATEGORIES_3')}
                      {sortTable?.sortPropertyName === 'catThreeId' ? returnObject() : <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />}
                    </span>
                  </th>
                  <th
                    className="w-120px"
                    onClick={() => {
                      onSortColumn('catFourId');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('FILTER_OPTIONS.CATEGORY_SELECTION.CATEGORIES_4')}
                      {sortTable?.sortPropertyName === 'catFourId' ? returnObject() : <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />}
                    </span>
                  </th>

                  <th
                    className="w-125px"
                    onClick={() => {
                      onSortColumn('seasonId');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('FILTER_OPTIONS.CATEGORY_SELECTION.SEASONS')}
                      {sortTable?.sortPropertyName === 'seasonId' ? returnObject() : <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />}
                    </span>
                  </th>

                  <th
                    className="w-120px"
                    onClick={() => {
                      onSortColumn('type');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('FILTER_OPTIONS.CATEGORY_SELECTION.ACTION_TYPE')}
                      {sortTable?.sortPropertyName === 'type' ? returnObject() : <ChevronIcon size={24} className="text-black ml-1 icon-inverse" />}
                    </span>
                  </th>

                  <th
                    className="w-120px"
                    onClick={() => {
                      onSortColumn('section');
                    }}
                  >
                    <span className="cursor-pointer text-nowrap">
                      {t('FILTER_OPTIONS.CATEGORY_SELECTION.SECTION')}
                      {sortTable?.sortPropertyName === 'section' ? returnObject() : <ChevronIcon size={24} className="text-black mr-1 icon-inverse" />}
                    </span>
                  </th>

                  {!isSupplierLoggedIn && <th className="w-110px">{t('FILTER_OPTIONS.CATEGORY_SELECTION.SUPPLIER')}</th>}
                  <th className="w-90px last-fix-col">{t('FILTER_OPTIONS.CATEGORY_SELECTION.STATUS')}</th>
                  <th />
                </tr>
              </thead>

              <tbody className="border_bottom_z">
                {state.suggestionListArray && state.suggestionListArray.length > 0 ? (
                  <>
                    {state.suggestionListArray.map((item) => (
                      <tr key={item?._id} className="text-center">
                        <td>
                          <img width="48" alt="product img" src={item.image || noImage} />
                        </td>

                        <td className="first-fix-col ">
                          <span
                            onClick={() => {
                              if (switchToAccessModal(item?.section)) {
                                routeToSection(item);
                              }
                            }}
                            className=" text-underline font-medium cursor-pointer"
                          >
                            {shortenandHoverString(item?.number, 10) || '-'}
                          </span>
                        </td>
                        <td className="text-left">{shortenandHoverString(item?.description, 30) || '-'}</td>
                        <td className="text-left">{shortenandHoverString(item?.brandId, 20) || '-'}</td>
                        <td className="text-left">{shortenandHoverString(item?.subBrandId, 20) || '-'}</td>
                        <td className="text-left">{shortenandHoverString(item?.catOneId, 20) || '-'}</td>
                        <td className="text-left">{shortenandHoverString(item?.catTwoId, 20) || '-'}</td>
                        <td className="text-left">{shortenandHoverString(item?.catThreeId, 20) || '-'}</td>
                        <td className="text-left">{shortenandHoverString(item?.catFourId, 20) || '-'}</td>
                        <td className="text-left">{shortenandHoverString(item?.seasonId, 10) || '-'}</td>
                        <td className="text-capitalize text-left">{item.type}</td>

                        <td className="text-left">{renderSectionDisplays(item)}</td>

                        {!isSupplierLoggedIn && <td className="text-left text-capitalize">{shortenandHoverString(item.supplierId, 20)}</td>}
                        <td className="text-left text-capitalize text-bold last-fix-col">
                          {item.section === 'bom' && <>{showStatus(item.bomComponents)}</>}
                          {item.section === 'testing' && <>{showStatus(item.testLibraries)}</>}
                          {item.section === 'measurement' && <>{showMeasurementStatus(item.measurementLibaries)}</>}
                          {item.section === careLabel && <>{showCareLabelStatus(item.careLableLibaries)}</>}
                          {item.section === 'product-information' && <>{showStatus(item.productInformationLibraries)}</>}
                        </td>
                        <td className="text-right">
                          <div className="d-flex justify-content-end action-suggestion align-items-center">
                            <CustomTooltip tooltipText={t('FILTER_OPTIONS.CATEGORY_SELECTION.VIEW')}>
                              <button
                                type="button"
                                aria-label="button"
                                onClick={() =>
                                  history.push({
                                    pathname: `/supplier-suggestion/detail/${item._id}/${item?.section}`,
                                  })
                                }
                                className="btn p-0 d-inline-flex mx-0"
                              >
                                <PreviewIcon size={24} />
                              </button>
                            </CustomTooltip>

                            {showHideBtn(item) && (
                              <CustomTooltip tooltipText={t('FILTER_OPTIONS.CATEGORY_SELECTION.EDIT')}>
                                <button type="button" aria-label="button" className="btn d-inline-flex p-0" onClick={() => editSuggesDetails(item)}>
                                  <EditIcon size={24} />
                                </button>
                              </CustomTooltip>
                            )}

                            <CustomTooltip tooltipText={t('FILTER_OPTIONS.CATEGORY_SELECTION.DELETE')}>
                              <button
                                type="button"
                                aria-label="button"
                                onClick={() => {
                                  onDelete(item._id);
                                }}
                                className="btn p-0 d-inline-flex mx-0"
                              >
                                <DeleteIcon size={24} />
                              </button>
                            </CustomTooltip>
                            {showCreatedandModified(item)}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  !state.loading &&
                  state.suggestionListArray.length === 0 && (
                    <tr>
                      <td colSpan={userRole === 'Supplier' ? 13 : 14} className="text-center">
                        {t('FILTER_OPTIONS.CATEGORY_SELECTION.NO_RECORD_FOUND')}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={() => deleteSupplierConfirmed()}
          title={t('SUPPLIER_SUGGESTION.CONFIRM.TITLE')}
          message={t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE')}
          toggle={closeConfirmationsPopup}
          loading={confirmLoader}
        />
      )}
    </>
  );
}

export default SuggestionList;
